module.exports = __webpack_public_path__ + "img/brown leather bifold wallet on gray concrete floor.88a2cd6a.png";